import React from 'react';
import { Alert, Spacer } from '@koalafi/component-library';
import { Trans, useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

export enum ReviewAndSubmitAlertTypes {
  Default = 'Default',
  NewC2Exp = 'NewC2Exp',
  TermsAndConditions = 'TermsAndConditions',
  CreditFreeze = 'CreditFreeze',
  DebitCard = 'DebitCard',
  BankAccount = 'BankAccount',
}

export interface ReviewAndSubmitAlertProps {
  type?: ReviewAndSubmitAlertTypes;
}

export const getAlertTextMap = (t: TFunction) => ({
  [ReviewAndSubmitAlertTypes.Default]: {
    message: t(($) => $.componentReviewAndSubmitAlert.defaultMessage),
  },
  [ReviewAndSubmitAlertTypes.NewC2Exp]: {
    message: (
      <span>
        <Trans i18nKey={($) => $.componentReviewAndSubmitAlert.newC2ExpMessage} components={{ strong: <strong /> }} />
      </span>
    ),
  },
  [ReviewAndSubmitAlertTypes.TermsAndConditions]: {
    message: t(($) => $.componentReviewAndSubmitAlert.termsAndConditionsMessage),
  },
  [ReviewAndSubmitAlertTypes.CreditFreeze]: {
    message: t(($) => $.componentReviewAndSubmitAlert.creditFreezeMessage),
    action: {
      label: t(($) => $.componentReviewAndSubmitAlert.creditFreezeActionLabel),
      to: 'https://consumers.clarityservices.com/securityFreeze',
    },
  },
  [ReviewAndSubmitAlertTypes.DebitCard]: {
    message: t(($) => $.componentReviewAndSubmitAlert.debitCardMessage),
  },
  [ReviewAndSubmitAlertTypes.BankAccount]: {
    message: t(($) => $.componentReviewAndSubmitAlert.bankAccountMessage),
  },
});

export const ReviewAndSubmitAlert = ({ type = ReviewAndSubmitAlertTypes.Default }: ReviewAndSubmitAlertProps) => {
  const { t } = useTranslation();
  const AlertTextMap: {
    [key in ReviewAndSubmitAlertTypes]: {
      message: string | React.ReactNode;
      action?: {
        label: string;
        to: string;
      };
    };
  } = getAlertTextMap(t);
  return (
    <Alert size="md" type="error">
      {AlertTextMap[type].message}
      {!!AlertTextMap[type].action && (
        <>
          <Spacer size="xs" />
          <a href={AlertTextMap[type].action.to}>{AlertTextMap[type].action.label}</a>
        </>
      )}
    </Alert>
  );
};

export default ReviewAndSubmitAlert;
